import React from "react";
import { Link, useNavigate } from "react-router-dom";
import classes from "./cardStyles.module.css";
export default function RTKCard({
  icon,
  title,
  path,
  description,
  colour,
  link,
  toHTML,
}) {
  const nav = useNavigate();

  // console.log("in RTKCard tohtml", toHTML);
  
  if (toHTML) {
    return (
      <a href={path}>
        <li className={`${colour} ${classes.card}`}>
          <div className="upper">{icon}</div>
          <div className="lower pt-4">
            <h2>{title}</h2>
            <p className="pt-4">{description}</p>
          </div>
        </li>
      </a>
    );
  } else {
    return (
      <a onClick={() => nav(path)}>
        <li className={`${colour} ${classes.card}`}>
          <div className="upper">{icon}</div>
          <div className="lower pt-4">
            <h2>{title}</h2>
            <p className="pt-4">{description}</p>
          </div>
        </li>
      </a>
    );
  }
}
